import { EnrichmentTypeEnum, FeatureFlags } from '@aibees/elephant/types';
import type { EnrichmentOption } from './types';

export const ENRICHMENT_OPTIONS: EnrichmentOption[] = [
  {
    name: 'Full People Enrichment',
    icon: 'supervisor',
    type: EnrichmentTypeEnum.PERSON,
  },
  {
    name: 'Full Company Enrichment',
    icon: 'business',
    type: EnrichmentTypeEnum.COMPANY,
  },
  {
    name: 'Email Enrichment',
    icon: 'email-check-outline',
    type: EnrichmentTypeEnum.EMAIL,
    featureFlag: FeatureFlags.EMAIL_ENRICHMENT,
  },
];
